import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { EvenementSpontane } from '../../../_models/EvenementSpontane';
import { PgmService } from '../../../_services/http/pgm.service';
import { ConfigService } from '../../../_services/local/config.service';
import { IPlanGestionMobilite } from '../../../_models/PlanGestionMobilite';
import { MainStoreState } from 'src/app/_store/mainStoreState';
import { DashboardService } from '../../dashboard/dashboard.service';
import { getCurrentUser } from 'src/app/_store/AccountStore/account.store';
import { hasSessionEdition } from 'src/app/_store/SessionStore/session.store';

@Component({
  selector: 'app-es-dialog-edit',
  templateUrl: './es-dialog-edit.component.html',
  styleUrls: ['./es-dialog-edit.component.scss'],
})
export class EsDialogEditComponent implements OnInit {
  form!: FormGroup;
  esTypes = [...this.configService.Config.esTypes];
  preconisations = [...this.configService.Config.preconisations];

  selectedPgm: IPlanGestionMobilite | undefined;

  get idPgmCtrl(): FormControl {
    return (this.form.get('pgm') as FormGroup).get('id') as FormControl;
  }

  get descriptionPgmCtrl(): FormControl {
    return (this.form.get('pgm') as FormGroup).get('description') as FormControl;
  }

  get numeroPgmCtrl(): FormControl {
    return (this.form.get('pgm') as FormGroup).get('numero') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private pgmService: PgmService,
    private configService: ConfigService,
    private store: Store<MainStoreState>,
    private dashboardService: DashboardService,
    public dialogRef: MatDialogRef<EsDialogEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { es: EvenementSpontane; updatePosition: boolean }
  ) {
    console.debug('ES edition', this.data);
    this.dialogRef.disableClose = true;
    this.initForm();
  }

  ngOnInit(): void {
    this.store.select(getCurrentUser).subscribe((user) => {
      this.store.select(hasSessionEdition(user)).subscribe((sessionEdition) => {
        if (!sessionEdition) {
          this.dashboardService.closeWidget('MapEditComponent');
        }
      });
    });
  }

  getPgm(): void {
    const idSegment = this.form.value.idSegment;
    const idTypeEs = this.form.value.idType;

    this.pgmService.retrieveFrom(idSegment, idTypeEs).subscribe((result) => {
      if (result) {
        this.selectedPgm = result;
        this.descriptionPgmCtrl.setErrors({
          notFound: null,
        });
        this.idPgmCtrl.setValue(this.selectedPgm.id);
        this.descriptionPgmCtrl?.setValue(this.selectedPgm.description || this.selectedPgm.id);
        this.numeroPgmCtrl.setValue(this.selectedPgm.numero);
      } else {
        this.idPgmCtrl.setValue(null);
        this.descriptionPgmCtrl?.setValue(null);
        this.descriptionPgmCtrl.setErrors({
          notFound: true,
        });
        this.numeroPgmCtrl.setValue(null);
      }

      this.idPgmCtrl.markAsTouched();
      this.descriptionPgmCtrl.markAsTouched();
      this.numeroPgmCtrl.markAsTouched();
    });
  }

  validateEs(): void {
    if (!this.form.valid || this.form.pristine || !this.selectedPgm) {
      return;
    }

    const es = new EvenementSpontane(this.form.value);

    if (this.data.es.hasId) {
      es.id = this.data.es.id;
    }

    this.dialogRef.close(es);
  }

  updatePosition(): void {
    this.dialogRef.close({ updatePosition: true });
  }

  private initForm(): void {
    const idSegment = Number(this.data.es.idSegment);

    this.form = this.fb.group({
      id: new FormControl(this.data.es.id),
      idSegment: new FormControl(idSegment, Validators.required),
      actif: new FormControl(this.data.es.actif),
      idType: new FormControl(this.data.es.idType, Validators.required),
      idPreconisation: new FormControl(this.data.es.idPreconisation, Validators.required),
      pgm: new FormGroup({
        id: new FormControl(this.data.es.pgm?.id, Validators.required),
        description: new FormControl(this.data.es.pgm?.description, Validators.required),
        numero: new FormControl(this.data.es.pgm?.numero, Validators.required),
      }),
    });

    if (this.data.es && this.data.es.pgm?.id != null && this.data.es.pgm.description != null) {
      this.selectedPgm = this.data.es.pgm;
    }

    if (this.data.updatePosition) {
      this.form.markAsDirty();
    }

    // in case of edition of the es
    // auto load the pgm
    if (this.data.es.idType && this.data.es.idSegment) {
      this.getPgm();
    }
  }
}
